const authReducer = (
  state = {
    loading: false,
    customAuthLoading: false,
    data: {
      accessToken: null,
      uid: null,
      phoneNumber: null,
      displayName: null
    },
    attempt: false,
    oAuth: {
      accessToken: null
    },
    credentials: {
      verificationId: null,
      authCredential: null
    }
  },
  action
) => {
  switch (action.type) {
    case "SET_AUTH_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_CUSTOM_AUTH_LOADING":
      return {
        ...state,
        customAuthLoading: action.payload.loading
      };

    case "SET_ACCESS_TOKEN":
      return {
        ...state,
        data: {
          ...state.data,
          accessToken: action.payload.accessToken
        }
      };

    case "SET_OAUTH_TOKEN":
      return {
        ...state,
        oAuth: {
          accessToken: action.payload.accessToken
        }
      };

    case "SET_AUTH_INFO":
      return {
        ...state,
        data: {
          accessToken: action.payload.accessToken,
          uid: action.payload.uid,
          phoneNumber: action.payload.phoneNumber,
          displayName: action.payload.displayName,
          transactionId: action.payload.transactionId,
          authMode: action.payload.authMode,
          validProfiles: action.payload.validProfiles,
          abdmToken: action.payload.abdmToken,
          abdmConfirmToken: action.payload.abdmConfirmToken,
          customToken: action.payload.customToken,
          ABDMRefreshToken: action.payload.ABDMRefreshToken
        }
      };

    case "SET_AUTH_DISPLAY_NAME":
      return {
        ...state,
        data: {
          ...state.data,
          displayName: action.payload.displayName
        }
      };

    case "SET_AUTH_VERIFICATION_ID":
      return {
        ...state,
        credentials: {
          ...state.credentials,
          verificationId: action.payload.verificationId
        }
      };

    case "SET_AUTH_CREDENTIALS":
      return {
        ...state,
        credentials: {
          ...state.credentials,
          authCredential: action.payload.authCredential
        }
      };

    case "REMOVE_AUTH_CREDENTIALS":
      return {
        ...state,
        credentials: {
          verificationId: null,
          authCredential: null
        }
      };

    case "SET_AUTH_SIGNUP_ATTEMPT":
      return {
        ...state,
        attempt: action.payload.phoneNumber
      };

    case "RESET":
      return {
        loading: false,
        customAuthLoading: false,
        data: {
          accessToken: null,
          uid: null,
          phoneNumber: null,
          displayName: null
        },
        attempt: false,
        oAuth: {
          accessToken: null
        },
        credentials: {
          verificationId: null,
          authCredential: null
        }
      };

    default:
      return state;
  }
};
export default authReducer;
